<template>
	<UITopHeading>Kontakt</UITopHeading>
	<div class="container flex flex-col">
		<div class="md:mx-8">
			<p>
				Falls du Fragen hast, die nicht in den FAQs auftauchen, besuch doch
				bitte unseren Instagram Account und schreib uns dort eine DM. Ansonsten
				kannst du uns auch gern per Mail erreichen
			</p>
			<p>
				<a href="mailto:jugendreferat-rv@bdkj-bja.drs.de">
					Juref E-Mail Adresse
				</a>
			</p>
			<p>
				<a href="https://www.instagram.com/propellerfestival/">Instagram</a>
			</p>
		</div>
	</div>
</template>

<script setup lang="ts">
useSeoMeta({
	title: 'Kontakt',
	ogTitle: 'Kontakt',
	twitterTitle: 'Kontakt',
	description: 'Die Kontaktinformationen für das Propellerfestival.',
	ogDescription: 'Die Kontaktinformationen für das Propellerfestival.',
	twitterDescription: 'Die Kontaktinformationen für das Propellerfestival.',
	ogUrl: 'https://propellerfestival.de/kontakt',
})
</script>
